import { render, staticRenderFns } from "./DataConfigForm.vue?vue&type=template&id=b6498b7c"
import script from "./DataConfigForm.vue?vue&type=script&lang=js"
export * from "./DataConfigForm.vue?vue&type=script&lang=js"
import style0 from "./DataConfigForm.vue?vue&type=style&index=0&id=b6498b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports